<script lang="ts" setup>
withDefaults(defineProps<{
  tournament: Tournament
  customRoute?: string
  withoutBanner?: boolean
}>(), { withoutBanner: false, customRoute: undefined })

const localePath = useLocalePath()
const tournamentType = useEnumTournamentType()
const tournamentGender = useEnumGenderGroup()
</script>

<template>
  <UiListItem
    :to="customRoute ? customRoute : localePath(`/tournaments/${tournament.id}`)"
    :class="{ 'opacity-50': tournament.listing_only && tournament.url }"
  >
    <div
      v-if="!withoutBanner"
      class="w-14 h-14 shrink-0 flex items-start justify-center"
    >
      <NuxtImg
        v-if="tournament.image"
        :src="tournament.image.replace('dartsspace.test', 'api.dartsspace.com')"
        :alt="`Tournament logo or poster ${tournament.name} | ${tournament.event_name}`"
        fit="contain"
        class="rounded-lg max-h-14 max-w-14 w-auto"
        width="100"
        height="100"
        placeholder
        quality="80"
        loading="lazy"
      />
      <UiAvatar
        v-else
        :fallback="`${tournament.name[0]}${tournament.event_name[0]}`"
      />
    </div>
    <UiListContent class="flex-1">
      <UiListTitle>
        {{ tournament.name }} @ {{ tournament.event_name }}
      </UiListTitle>
      <UiListSubtitle as="div">
        <UiBadge variant="outline">
          {{ tournamentType.getLabel(tournament.type) }}
        </UiBadge>
        <UiBadge variant="outline">
          {{ tournamentGender.getLabel(tournament.gender) }}
        </UiBadge>
      </UiListSubtitle>
      <UiListSubtitle as="div">
        <TournamentStatusBadge :tournament="tournament" />
      </UiListSubtitle>
      <UiListSubtitle>
        <CommonDateTime :date="tournament.starts_at" />
      </UiListSubtitle>
      <UiListSubtitle>
        {{ tournament.address_simple }}
      </UiListSubtitle>
      <UiListSubtitle v-if="tournament.complete && tournament.personal_result">
        {{ $t('Your result: ') }} {{ tournament.personal_result }}
      </UiListSubtitle>
      <UiListSubtitle
        v-if="tournament.ranking_name"
        as="div"
      >
        <UiBadge
          variant="outline"
        >
          {{ $t('Ranking:') }} {{ tournament.ranking_name }}
        </UiBadge>
      </UiListSubtitle>
      <div class="flex flex-row gap-2 justify-end">
        <template v-if="!$slots.actions">
          <UiButton
            size="xs"
            icon="tabler:arrow-right"
            :variant="(tournament.registration_possible === 'yes' || tournament.registration_possible === 'waiting_list') ? 'success' : 'default'"
            icon-placement="right"
          >
            <template v-if="(tournament.registration_possible === 'yes' && tournament.registration_status !== 'registered') || tournament.registration_possible === 'waiting_list'">
              {{ $t('View & Register') }}
            </template>
            <template v-else-if="tournament.registration_status === 'registered' || tournament.registration_status === 'on_waiting_list'">
              {{ $t('Manage registration') }}
            </template>
            <template v-else>
              {{ $t('View') }}
            </template>
          </UiButton>
        </template>
        <template v-else>
          <slot name="actions" />
        </template>
      </div>
    </UiListContent>
  </UiListItem>
</template>
